module.exports = __webpack_public_path__ + "assets/img/bp_d_i_5.ed5101aa.jpg";